"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillMatrixStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.SkillMatrixStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  >.title {
    padding: 0 1em;
    font-weight: 600;
  }

  >.skills {
    display: flex;
    flex-flow: row wrap;
    gap: 0.5em;
    align-items: center;
    justify-content: flex-start;
    padding: 1.5em 1em 1em;

    > button.skill {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      height: 1.25em;
      padding: 0 0.5em;
      border-radius: 0.625em;
      background-color: ${design_system_1.theme.colors.cyan[70]};
      color: ${design_system_1.theme.colors.marine[100]};
      font-weight: 600;
      cursor: pointer;

      > span {
        overflow: hidden;
        max-width: 14rem;
        font-size: 0.75em;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  >.track {
    overflow-x: auto;
    min-width: 100%;

    > table {
      width: 100%;

      > thead {
        > tr {
          > th {
            vertical-align: middle;
            padding: 1em;
            font-weight: 600;

            >.motivation {
              >.title {
                @media (min-width: ${constants_1.sizes.tablet}) {
                  display: block;
                }

                @media (max-width: ${constants_1.sizes.tablet}) {
                  display: none;
                }
              }

              >.icons {
                @media (min-width: ${constants_1.sizes.tablet}) {
                  flex-direction: row;
                }

                @media (max-width: ${constants_1.sizes.tablet}) {
                  flex-direction: column-reverse;
                }
              }
            }

            &:not(:first-child) {
              width: 20%;
            }
          }
        }
      }

      > tbody {
        > tr {
          border-top: 0.0625em solid ${design_system_1.theme.colors.marine[20]};

          > th {
            vertical-align: middle;
            font-weight: 600;

            @media (min-width: ${constants_1.sizes.tablet}) {
              padding: 1em;
            }

            @media (max-width: ${constants_1.sizes.tablet}) {
              padding: 0.5em;
            }

            >.level {
              > span {
                @media (min-width: ${constants_1.sizes.tablet}) {
                  display: block;
                }

                @media (max-width: ${constants_1.sizes.tablet}) {
                  display: none;
                }
              }

              >.icons {
                @media (min-width: ${constants_1.sizes.tablet}) {
                  flex-flow: row nowrap;
                  align-items: center;
                }

                @media (max-width: ${constants_1.sizes.tablet}) {
                  flex-flow: column-reverse nowrap;
                  align-items: flex-start;
                }
              }
            }
          }

          > td {
            vertical-align: middle;

            @media (min-width: ${constants_1.sizes.tablet}) {
              padding: 1em;
            }

            @media (max-width: ${constants_1.sizes.tablet}) {
              padding: 0.5em;
            }

            > button {
              overflow: hidden;
              width: 100%;
              max-width: 18vw;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;

              &:hover {
                >.affinity {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=SkillMatrix.styled.js.map